import { render, staticRenderFns } from "./UHero.vue?vue&type=template&id=5e47e36c&"
import script from "./UHero.vue?vue&type=script&lang=js&"
export * from "./UHero.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports